import { Alert, AlertTitle } from '@mui/material';
import React from 'react';
import { firstLetterUpperCase } from '../../commons/utils';

export const AlertsInformativos = ({ type, title, content }: any) => {
  return (
    <>
      <Alert severity={type}>
        <AlertTitle>{firstLetterUpperCase(title.toLowerCase())}</AlertTitle>
        {firstLetterUpperCase(content.toLowerCase())}
      </Alert>
    </>
  );
};
